<template>
  <div class="my-top box-con z-flex z-flex-between">
    <div class="item" v-for="(item,index) in menuList" :key="index">
      <div class="text z-flex z-flex-between">
        <span>{{item.title}}</span>
        <el-button size="mini" @click="toUrl(item.url)">{{item.btnText}}<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
      <div class="num">{{item.num}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "myTop",
  props: {
    
  },
  data() {
    return {
      menuList:[
        {
          title:'当前修图包',
          num:0,
          url:'',
          btnText:'立即购买',
        },{
          title:'我的收藏',
          num:0,
          url:'/my/collects',
          btnText:'查看收藏',
        },{
          title:'红包卡券',
          num:0,
          url:'/my/coupons',
          btnText:'领券中心',
        },{
          title:'已学习课程',
          num:0,
          url:'/course/list',
          btnText:'继续学习',
        },
      ],
    };
  },
  mounted() {
    this.$axios.api.request({
      url: "/api/qtclub/user/myTop",
    }, (res) => {
      this.menuList[0].num = res.data.psNum;
      this.menuList[1].num = res.data.collectNum;
      this.menuList[2].num = res.data.couponNum;
      this.menuList[3].num = res.data.courseNum;
    })
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.my-top{
  .item{
    width:25%;
    margin:20px 0;
    padding: 0 20px 0 30px;
    box-sizing: border-box;
    position: relative;
    .text{
      font-size: 15px;
      color: #777;
      .el-button{
        padding: 7px;
      }
    }
    .num{
      margin-top: 10px;
      font-size: 35px;
      font-weight: 700;
      font-family: Arial, Helvetica, sans-serif;
    }
    &::after{
      content: "";
      width: 1px;
      height:48px;
      display: block;
      background:#ededed;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -24px;
    }
    &:first-child::after{
      display: none;
    }
  }
}
</style>
